/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * Interal demo data and utilities used for example apps and documentation
 */
export * from './utils.js';
export * from './data/demo.service.js';
export * from './data/interfaces.js';
export var StatusDisplayType;
(function (StatusDisplayType) {
    StatusDisplayType["online"] = "success";
    StatusDisplayType["disruption"] = "warning";
    StatusDisplayType["offline"] = "danger";
    StatusDisplayType["deactivated"] = "neutral";
})(StatusDisplayType || (StatusDisplayType = {}));
export var StatusIconType;
(function (StatusIconType) {
    StatusIconType["online"] = "check-circle";
    StatusIconType["disruption"] = "exclamation-triangle";
    StatusIconType["offline"] = "exclamation-circle";
    StatusIconType["deactivated"] = "disconnect";
})(StatusIconType || (StatusIconType = {}));
export var ColumnTypes;
(function (ColumnTypes) {
    ColumnTypes[ColumnTypes["Host"] = 1] = "Host";
    ColumnTypes[ColumnTypes["Status"] = 2] = "Status";
    ColumnTypes[ColumnTypes["CPU"] = 4] = "CPU";
    ColumnTypes[ColumnTypes["Memory"] = 8] = "Memory";
    ColumnTypes[ColumnTypes["All"] = 15] = "All";
})(ColumnTypes || (ColumnTypes = {}));
/**
 * @demo
 * This is a demo function used to standardize demos across framework examples. Do not use in production.
 */
export function getVMData() {
    return [
        { id: 'vm-host-001', status: 'online', cpu: 5, memory: 10, selected: false, about: 'Lorem ipsum dolor sit amet' },
        { id: 'vm-host-003', status: 'online', cpu: 10, memory: 30, selected: false, about: 'Lorem ipsum dolor sit amet' },
        { id: 'vm-host-002', status: 'online', cpu: 20, memory: 30, selected: false, about: 'Lorem ipsum dolor sit amet' },
        { id: 'vm-host-011', status: 'online', cpu: 5, memory: 15, selected: false, about: 'Lorem ipsum dolor sit amet' },
        { id: 'vm-host-004', status: 'offline', cpu: 90, memory: 80, selected: false, about: 'Lorem ipsum dolor sit amet' },
        { id: 'vm-host-016', status: 'online', cpu: 5, memory: 15, selected: false, about: 'Lorem ipsum dolor sit amet' },
        {
            id: 'vm-host-008',
            status: 'disruption',
            cpu: 50,
            memory: 60,
            selected: false,
            about: 'Lorem ipsum dolor sit amet',
        },
        { id: 'vm-host-018', status: 'offline', cpu: 0, memory: 0, selected: false, about: 'Lorem ipsum dolor sit amet' },
        {
            id: 'vm-host-006',
            status: 'deactivated',
            cpu: 0,
            memory: 0,
            selected: false,
            about: 'Lorem ipsum dolor sit amet',
        },
        { id: 'vm-host-005', status: 'offline', cpu: 85, memory: 70, selected: false, about: 'Lorem ipsum dolor sit amet' },
        {
            id: 'vm-host-014',
            status: 'disruption',
            cpu: 73,
            memory: 62,
            selected: false,
            about: 'Lorem ipsum dolor sit amet',
        },
        { id: 'vm-host-017', status: 'offline', cpu: 0, memory: 0, selected: false, about: 'Lorem ipsum dolor sit amet' },
        {
            id: 'vm-host-007',
            status: 'deactivated',
            cpu: 0,
            memory: 0,
            selected: false,
            about: 'Lorem ipsum dolor sit amet',
        },
        {
            id: 'vm-host-010',
            status: 'disruption',
            cpu: 50,
            memory: 60,
            selected: false,
            about: 'Lorem ipsum dolor sit amet',
        },
        {
            id: 'vm-host-009',
            status: 'disruption',
            cpu: 65,
            memory: 90,
            selected: false,
            about: 'Lorem ipsum dolor sit amet',
        },
        { id: 'vm-host-012', status: 'offline', cpu: 85, memory: 70, selected: false, about: 'Lorem ipsum dolor sit amet' },
        {
            id: 'vm-host-020',
            status: 'deactivated',
            cpu: 0,
            memory: 0,
            selected: false,
            about: 'Lorem ipsum dolor sit amet',
        },
        {
            id: 'vm-host-013',
            status: 'deactivated',
            cpu: 0,
            memory: 0,
            selected: false,
            about: 'Lorem ipsum dolor sit amet',
        },
        { id: 'vm-host-015', status: 'online', cpu: 15, memory: 20, selected: false, about: 'Lorem ipsum dolor sit amet' },
        { id: 'vm-host-019', status: 'online', cpu: 34, memory: 28, selected: false, about: 'Lorem ipsum dolor sit amet' },
    ];
}
/**
 * @demo
 * This is a demo function used to standardize demos across framework examples. Do not use in production.
 */
export function getVMDataAsync(delay = 0) {
    return new Promise(resolve => setTimeout(() => resolve(getVMData()), delay));
}
